import React, {useContext, useState} from 'react';
import {CollapsibleSection, joinClassNames, SegmentedButton, SelectInput, Size, TextArea, TextInput} from "@dts-soldel/dts-react-common";
import MobXContext from "../../../../app/mobx/MobXContext";
import {observer} from "mobx-react";
import IconTypes from "../IconInput/IconTypes";
import IconInputOnClick from "./IconInputOnClick";
import IconInputPopupContent from "./IconInputPopupContent";
import PropTypes from "prop-types";
import IconInputMenu from "./IconInputMenu";
import HelpIcon from "../../HelpIcon/HelpIcon";
import HelpText from "../../HelpIcon/HelpText";
import Icons from "../../../../misc/Icon";

const propTypes = {
	iconName: PropTypes.string.isRequired,
	iconTitle: PropTypes.string.isRequired,
};
const defaultProps = {};

const IconInputCommon = ({iconName, iconTitle}) => {
	const {configuratorStore} = useContext(MobXContext);
	const [isExpanded, setIsExpanded] = useState(false);
	const helpText = {
		iconShowTitle: HelpText[`${iconName}IconShowTitle`],
		iconOnHover: HelpText[`${iconName}IconOnHover`],
		iconTitle: HelpText[`${iconName}IconTitle`],
		iconType: HelpText[iconName],
	};

	return (
		<div className="configurator__inputs__input">
			<CollapsibleSection
				clickSection={() => setIsExpanded(!isExpanded)}
				expanded={isExpanded}
				title={`${iconTitle} Icon${configuratorStore[`${iconName}IconType`] === IconTypes.none ? '' : ` - ${configuratorStore[`${iconName}IconType`]}`}`}
				collapsibleIndicator={Icons.iconArrowRight()}
				className={joinClassNames(configuratorStore[`${iconName}IconType`] !== 'none' ? 'configured' : undefined, 'mb1')}
			>
				<SegmentedButton
					field={`${iconName}IconType`}
					label={`${iconTitle} Icon Type`}
					className="segmented-button full-width"
					options={[
						{label: 'None', value: IconTypes.none},
						{label: 'Menu', value: IconTypes.menu},
						{label: 'onClick', value: IconTypes.onClick},
						{label: 'Popup Content', value: IconTypes.popupContent},
					]}
					value={configuratorStore[`${iconName}IconType`]}
					showLabel={false}
					onChange={configuratorStore.setFieldValue}
					children={
						<HelpIcon
							popOverText={helpText.iconType}
							onUseExampleField={helpText.iconType.exampleValue ? `${iconName}IconType` : undefined}
							onUseExampleFieldValue={helpText.iconType.exampleValue ? configuratorStore.setFieldValue : undefined}
						/>
					}
				/>
				{
					configuratorStore[`${iconName}IconType`] !== IconTypes.none ?
						<>
							<TextInput
								size={Size.FULL_WIDTH}
								field={`${iconName}IconTitle`}
								label="Title"
								value={configuratorStore[`${iconName}IconTitle`]}
								onChange={configuratorStore.setFieldValue}
								children={
									<HelpIcon
										popOverText={helpText.iconTitle}
										onUseExampleField={helpText.iconTitle.exampleValue ? `${iconName}IconTitle` : undefined}
										onUseExampleFieldValue={helpText.iconTitle.exampleValue ? configuratorStore.setFieldValue : undefined}
									/>
								}
							/>
							<SelectInput
								size={Size.FULL_WIDTH}
								field={`${iconName}IconShowTitle`}
								label="Show Title"
								options={[
									{label: 'No', value: false},
									{label: 'Yes', value: true},
								]}
								value={configuratorStore[`${iconName}IconShowTitle`]}
								onChange={configuratorStore.setFieldValue}
								children={
									<HelpIcon
										popOverText={helpText.iconShowTitle}
										onUseExampleField={helpText.iconShowTitle.exampleValue ? `${iconName}IconShowTitle` : undefined}
										onUseExampleFieldValue={helpText.iconShowTitle.exampleValue ? configuratorStore.setFieldValue : undefined}
									/>
								}
							/>
							<TextArea
								size={Size.FULL_WIDTH}
								field={`${iconName}IconOnHover`}
								label="onHover"
								value={configuratorStore[`${iconName}IconOnHover`]}
								onChange={configuratorStore.setFieldValue}
								children={
									<HelpIcon
										popOverText={helpText.iconOnHover}
										onUseExampleField={helpText.iconOnHover.exampleValue ? `${iconName}IconOnHover` : undefined}
										onUseExampleFieldValue={helpText.iconOnHover.exampleValue ? configuratorStore.setFieldValue : undefined}
									/>
								}
							/>
							<div className="collapsible-section__divider"/>
						</>
						: undefined
				}
				{configuratorStore[`${iconName}IconType`] === IconTypes.onClick ? <IconInputOnClick iconName={iconName}/> : undefined}
				{configuratorStore[`${iconName}IconType`] === IconTypes.popupContent ? <IconInputPopupContent iconName={iconName}/> : undefined}
				{configuratorStore[`${iconName}IconType`] === IconTypes.menu ? <IconInputMenu iconName={iconName}/> : undefined}
			</CollapsibleSection>
		</div>
	);
};

IconInputCommon.propTypes = propTypes;
IconInputCommon.defaultProps = defaultProps;

export default observer(IconInputCommon);
